export interface Permission {
	resource: string;
	action: string;
}

/**
 * Rolning ma'lumot ko'lami — backend `RoleScopeSchema` bilan AYNI ro'yxat.
 * ⚠️ Doirasiz rol backend'da jimgina `self` bo'lardi
 * (`resolveScopeFromRoles`), shu sabab formada majburiy.
 */
export const ROLE_SCOPES = ["global", "department", "self"] as const;

export type RoleScope = (typeof ROLE_SCOPES)[number];

export function isRoleScope(value: unknown): value is RoleScope {
	return typeof value === "string" && (ROLE_SCOPES as readonly string[]).includes(value);
}

/**
 * `*` ruxsatli rol (seed'dagi `admin`) — backend uning ruxsatlari va
 * doirasini o'zgartirishni rad etadi, matritsa esa `*` ni ko'rsata olmaydi.
 */
export function hasWildcardPermission(permissions: Permission[]): boolean {
	return permissions.some((permission) => permission.resource === "*" || permission.action === "*");
}

export interface ManagedRole {
	id: string;
	name: string;
	description?: string | null;
	permissions: Permission[];
	inherits?: string[] | null;
	/** Eski qatorlarda `null` yoki enum'dan tashqari qiymat bo'lishi mumkin. */
	scope?: string | null;
	metadata?: Record<string, unknown> | null;
	/** Seed yaratadigan tizim roli — o'chirilmaydi. */
	isSystem: boolean;
}

export interface ResourceDescriptor {
	name: string;
	actions: string[];
}

export interface CreateRoleInput {
	id: string;
	name: string;
	description?: string;
	scope: RoleScope;
	permissions: Permission[];
}

export interface UpdateRoleInput {
	name?: string;
	description?: string;
	scope?: RoleScope;
	permissions?: Permission[];
}
